export default __webpack_public_path__ + "static/media/797198458997964830.7b3961aa.png";